import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=e53ac22a&"
import script from "./Transfers.vue?vue&type=script&lang=js&"
export * from "./Transfers.vue?vue&type=script&lang=js&"
import style0 from "./Transfers.vue?vue&type=style&index=0&id=e53ac22a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports